<template>
<div>
  <div class="mb-2">
  <div class="row" v-if="hasRole('Mitglied') || auftrag.cutterId===user.id">
   <div class="col-12 col-sm-3 label">Kunde: <a :href="encodeVCard(auftrag)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-vcard" viewBox="0 0 16 16">
  <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"/>
  <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z"/>
</svg></a></div>
   <div class="col-12 col-sm-7">{{auftrag.kundeFormular}}</div>
  </div>
  <div class="row">
   <div class="col-12 col-sm-3  label">Sendung:</div>
   <div class="col-12 col-sm-7">{{auftrag.sendung}}</div>
   </div>
  <div class="row" v-if="auftrag.thema">
   <div class="col-12 col-sm-3  label">Thema:</div>
   <div class="col-12 col-sm-7">{{auftrag.thema}}</div>
   </div>
  <div class="row">
   <div class="col-12 col-sm-3  label">Anzahl Tage:</div>
    <div class="col-12 col-sm-7">{{auftrag.tage ? auftrag.tage + ' Tage': auftrag.tageFormular}}</div>
 </div>
  <div class="row">
    <div class="col-12 col-sm-3  label">im Zeitraum: <a v-if="convertToICalDate(auftrag.datum)!=null" :href="encodeICal(auftrag)"><i class="bi bi-calendar-date"></i></a>
    </div>
    <div class="col-12 col-sm-7">{{auftrag.datum}}</div>
 </div>
  <div class="row">
   <div class="col-12 col-sm-3  label">Schnittsoftware:</div>
    <div class="col-12 col-sm-7">{{auftrag.skill.name}}</div>
 </div>
  <div class="row">
   <div class="col-12 col-sm-3  label">Gage (8h):</div>
    <div class="col-12 col-sm-7">{{auftrag.gage ? auftrag.gage + ' €' : auftrag.gageFormular }}</div>
 </div>
  <div class="row" v-if="auftrag.technikMiete ">
   <div class="col-12 col-sm-3  label">Technikmiete:</div>
    <div class="col-12 col-sm-7">{{auftrag.technikMiete ? auftrag.technikMiete + ' €' : '' }}</div>
 </div>

    <b-form-group label-cols="12" v-if="auftrag.information"
      id="input-group-15" label="Infos vom Kunden:" label-for="input-15">
    <div>{{auftrag.information}}</div>
    </b-form-group>

    <b-form-group label-cols="12"
      v-if="auftrag.informationDispo"
      id="input-group-info-dispo" label="Infos vom Disponenten:"
      label-for="input-info-dispo">
    <div>{{auftrag.informationDispo}}</div>
    </b-form-group>

    <div>
    <h5 class="mt-3 label">Arbeitsort</h5>
    <div>
    {{findSchnittplatz(auftrag.schnittplatzId).name}}
    </div>
    <div v-if="(auftrag.firmaStrasse || auftrag.firmaPlz || auftrag.firmaOrt) && !findSchnittplatz(auftrag.schnittplatzId).useCutterAddress">
    <span v-if="hasRole('Mitglied') || auftrag.cutterId===user.id">
    {{auftrag.firmaStrasse ? auftrag.firmaStrasse+', ' : ''}}
    </span>
    {{auftrag.firmaPlz ? auftrag.firmaPlz+' ' : ''}}
    {{auftrag.firmaOrt}}
    </div>
    </div>
  </div>

  <div class="mb-2">
    <h5 class="mb-1 label">Abrechnung</h5>
    <div>
      {{findAbrechnungsArt()}}</div>
  </div>

  <div class="mb-2" v-if="auftrag.vermittlungsProvision">
    <h5 class="mb-1 label">Vermittlungsprovision</h5>
    <div>
      {{auftrag.vermittlungsProvision|number}}%</div>
  </div>

  <div class="mb-2" v-if="auftrag.cutterId===user.id">
    <h5 class="mb-1 label">Kontakt Kunde</h5>
    <div>{{auftrag.name?auftrag.name+', ':''}} <span v-html="phoneAsLink(auftrag.telefon)"> </span>
      {{auftrag.email}}</div>
  </div>

  <div class="mb-2">
    <h5 class="mb-1 label">Disposition</h5>
    <div v-if="auftrag.disponent">
      {{auftrag.disponent.name?auftrag.disponent.name+', ':''}} <span v-html="phoneAsLink(auftrag.disponent.telefon)"> </span>
      {{auftrag.disponent.username}}</div>
  </div>

  </div>
</template>
<script>
import utils from '@/utilities'

export default {
  props: ['user', 'auftrag', 'headerClass', 'aaMessage', 'editMode'],
  name: 'AuftragCutter',
  methods: {
    phoneAsLink (phone) {
      return phone ? '<a href="tel:' + phone + '">' + phone + '</a>, ' : ''
    },
    formatAdresse (auftrag) {
      let adr = []
      if (auftrag.firmaStrasse) {
        adr.push(auftrag.firmaStrasse)
      }
      if (auftrag.firmaPlz) {
        adr.push(auftrag.firmaPlz)
      }
      if (auftrag.firmaOrt) {
        adr.push(auftrag.firmaOrt)
      }
      return adr.join(', ')
    },
    convertToICalDate (str) {
      if (!str) {
        return null
      }

      const currentYear = new Date().getFullYear().toString()
      const regex = /^(\d{2})\.(\d{2})(?:\.(\d{2}|\d{4}))?\s*-\s*(\d{2})\.(\d{2})\.(\d{2}|\d{4})/
      const match = str.match(regex)

      if (match) {
        let day1 = match[1]
        let month1 = match[2]
        let year1 = match[3] ? (match[3].length === 2 ? `20${match[3]}` : match[3]) : currentYear

        let day2 = match[4]
        let month2 = match[5]
        let year2 = match[6].length === 2 ? `20${match[6]}` : match[6]

        const icalDate1 = `${year1}${month1}${day1}`
        const icalDate2 = `${year2}${month2}${day2}`
        return [icalDate1, icalDate2]
      }
      // Check for single date
      const singleDateRegex = /^(\d{2})\.(\d{2})\.(\d{4}|\d{2})/
      const singleMatch = str.match(singleDateRegex)

      if (singleMatch) {
        let day = singleMatch[1]
        let month = singleMatch[2]
        let year = singleMatch[3]

        // If year is in yy format, convert it to yyyy format
        if (year.length === 2) {
          year = `20${year}`
        }
        return [`${year}${month}${day}`]
      }
      return null // No valid date found
    },
    encodeICal (auftrag) {
      const dates = this.convertToICalDate(auftrag.datum)
      let ical = 'BEGIN:VCALENDAR\n' +
            'VERSION:2.0\n' +
            'BEGIN:VEVENT\n' +
            'SUMMARY:' + auftrag.kundeFormular + ' - ' + auftrag.thema + '\n'

      ical += 'DTSTART:' + dates[0] + '\n'
      if (dates[1]) {
        ical += 'DTEND:' + dates[1] + '\n'
      }
      if (this.formatAdresse(auftrag)) {
        ical += 'LOCATION:' + this.formatAdresse(auftrag) + '\n'
      }
      ical += 'DESCRIPTION: ' + auftrag.informationDispo + '\n'
      ical += 'END:VEVENT\n'
      ical += 'END:VCALENDAR\n'

      return 'data:text/calendar;charset=utf-8;base64,' + btoa(ical)
    },
    encodeVCard (auftrag) {
      let vcard = 'BEGIN:VCARD\nVERSION:3.0\nFN:' + auftrag.name + '\n'

      if (auftrag.telefon) {
        vcard += 'TEL;TYPE=CELL:' + auftrag.telefon + '\n'
      }
      if (auftrag.email) {
        vcard += 'EMAIL:' + auftrag.email + '\n'
      }
      vcard += 'END:VCARD\n'
      return 'data:text/vcard;base64,' + btoa(vcard)
    },
    hasRole (role) {
      return this.hasRoles([role])
    },
    hasRoles (role) {
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), role)
    },
    findSchnittplatz (schnittplatzId) {
      if (!schnittplatzId) {
        return {name: 'Schnittplatz nicht definiert'}
      }
      for (let i = 0; i < this.schnittplaetze.length; i++) {
        if (this.schnittplaetze[i].id === schnittplatzId) {
          return this.schnittplaetze[i]
        }
      }
      return {useAddress: false, useCutterAddress: false, name: ''}
    },
    findAbrechnungsArt () {
      for (let abAr of this.abrechnungOptions) {
        if (abAr.id === this.auftrag.abrechnungsArt) {
          return abAr.description
        }
      }
    }
  },
  updated () {
  },
  computed: {
    sendungThema: function () {
      return this.auftrag.sendung + ((this.auftrag.sendung && this.auftrag.thema) ? ' - ' + this.auftrag.thema : '')
    }
  },
  data () {
    return {
      schnittplaetze: this.$store.state.auth.baseData.schnittplaetze,
      abrechnungOptions: this.$store.state.auth.baseData.abrechnungsArten
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/AuftragCutter.vue